module.exports = __webpack_public_path__ + "media/mia_8mal7.e576c5c2.mp4";